var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-animation",class:{ anchored: _vm.anchored }},_vm._l((6),function(n){return _c('span',{key:n})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }